import * as badges from '../../../img/storeBadges'

interface StoreBadges {
	appStore: string
	googlePlay: string
}

const englishBadges: StoreBadges = {
	appStore: badges.appStoreEnglish,
	googlePlay: badges.googlePlayEnglish,
}

const badgesByLanguage: Record<string, StoreBadges> = {
	'it-IT': {
		appStore: badges.appStoreItalian,
		googlePlay: badges.googlePlayItalian,
	},
}

export function getStoreBadges(language: string): StoreBadges {
	return badgesByLanguage[language] ?? englishBadges
}
